export default __webpack_public_path__ + "8f4d695635d7c583f57fc952ad036691.svg";